import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Chapter, EASE } from "@/components/motion";

const SCENARIOS = [
  { q: "¿SE ROMPE EL AIRE ACONDICIONADO?", testid: "whatif-aire" },
  { q: "¿HAY UNA AVERÍA ELÉCTRICA?", testid: "whatif-electrica" },
  { q: "¿PROBLEMAS DE FONTANERÍA?", testid: "whatif-fontaneria" },
  { q: "¿UNA INCIDENCIA EN TU LOCAL?", testid: "whatif-local" },
];

export default function WhatIf() {
  const [active, setActive] = useState(0);
  return (
    <section className="relative py-32 lg:py-44 overflow-hidden" data-testid="section-que-pasa-si">
      <div className="mx-auto max-w-[1500px] px-6 lg:px-12">
        <Chapter num="07" label="QUÉ PASA SI…" className="mb-16" />
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-center">
          <div className="lg:col-span-7 space-y-2">
            {SCENARIOS.map((s, i) => (
              <button
                key={s.q}
                data-testid={s.testid}
                onMouseEnter={() => setActive(i)}
                onClick={() => setActive(i)}
                className={`group block w-full text-left py-5 border-b border-silver/10 transition-colors duration-300 ${
                  active === i ? "text-offwhite" : "text-steel hover:text-mist"
                }`}
              >
                <span className="flex items-baseline gap-5">
                  <span className="font-mono text-[10px] text-steel">{String(i + 1).padStart(2, "0")}</span>
                  <span className="font-display font-700 uppercase tracking-tight text-2xl sm:text-4xl lg:text-5xl leading-tight">
                    {s.q}
                  </span>
                </span>
              </button>
            ))}
          </div>
          <div className="lg:col-span-5 relative min-h-[10rem] lg:min-h-[18rem] flex items-center lg:justify-end">
            <AnimatePresence mode="wait">
              <motion.span
                key={active}
                initial={{ opacity: 0, y: 40, filter: "blur(8px)" }}
                animate={{ opacity: 1, y: 0, filter: "blur(0px)" }}
                exit={{ opacity: 0, y: -30, filter: "blur(8px)" }}
                transition={{ duration: 0.45, ease: EASE }}
                className="font-oswald font-700 uppercase text-7xl lg:text-9xl tracking-tight text-metal"
                data-testid="whatif-answer"
              >
                APREA.
              </motion.span>
            </AnimatePresence>
          </div>
        </div>
      </div>
    </section>
  );
}
